import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bottom-nav" }
const _hoisted_2 = { class: "nav-icon" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = {
  key: 0,
  class: "nav-pip"
}

import { useRoute } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomNavigation',
  setup(__props) {

const route = useRoute();
const store = useStore();

const navItems = [
  { name: 'home',     to: '/',               icon: 'fas fa-home',          label: 'Inicio'      },
  { name: 'students', to: '/students',        icon: 'fas fa-user-graduate', label: 'Estudiantes' },
  { name: 'recharge', to: '/recharge-select', icon: 'fas fa-credit-card',   label: 'Recargar'    },
  { name: 'settings', to: '/settings',        icon: 'fas fa-cog',           label: 'Perfil'      },
];

const isActive = (path: string) => route.path === path;
const handleLogout = () => store.dispatch('auth/signOff');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
      return _createVNode(_component_router_link, {
        key: item.name,
        to: item.to,
        class: _normalizeClass(["nav-item", { active: isActive(item.to) }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(item.icon)
            }, null, 2)
          ]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
          (isActive(item.to))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["to", "class"])
    }), 64)),
    _createElementVNode("div", {
      class: "nav-item nav-item--logout",
      onClick: handleLogout
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "nav-icon" }, [
        _createElementVNode("i", { class: "fas fa-sign-out-alt" })
      ], -1),
      _createElementVNode("span", { class: "nav-label" }, "Salir", -1)
    ]))])
  ]))
}
}

})